module.exports = __webpack_public_path__ + "img/app_phone_model.098cc2c5.png";